/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MFALoginSend = {
    mfa_method: MFALoginSend.mfa_method;
    username: string;
}

export namespace MFALoginSend {

    export enum mfa_method {
        EMAIL = 'email',
        SMS = 'sms',
    }


}
